<script>
import { GlIcon, GlLink, GlTooltipDirective } from '@gitlab/ui';

export default {
  components: {
    GlIcon,
    GlLink,
  },
  directives: {
    GlTooltip: GlTooltipDirective,
  },
  props: {
    vulnerability: {
      type: Object,
      required: true,
    },
  },
};
</script>
<template>
  <gl-link
    v-gl-tooltip="s__('Vulnerability|Comments')"
    :href="vulnerability.vulnerabilityPath"
    :data-testid="`vulnerability-comments-${vulnerability.id}`"
    class="gl-ml-3 gl-inline-flex gl-shrink-0 gl-items-center gl-text-default"
  >
    <gl-icon name="comment" />
  </gl-link>
</template>
